const CaseStatusNotifications: { [key: number]: any } = {
    0: {
        severity: 'info',
        text: 'The AppearMe engine is working hard to match you with a lawyer for your case. You will be notified once lawyers submit their proposals.'
    },
    1: {
        severity: 'info',
        text: 'Please Accept the lawyer that you think is the best match for you. To see more proposals you can Reject one or all of these proposals.'
    },
    3: {
        severity: 'warning',
        text: {
            'single_appearance': 'Please approve the work/ report submitted by the lawyer. Once you approve the lawyer will be paid.',
            'contingency': 'Please Approve the work product and/or the services submitted by the lawyer.',
            'pro_bono': 'Please Approve the work product and/or the services submitted by the lawyer.',
            'full_case_hourly': 'Please approve the work/ report submitted by the lawyer. Once you approve the lawyer will be paid.',
            'full_case_flat': 'Please approve the work/ report submitted by the lawyer. Once you approve the lawyer will be paid.',
        }
    },
    4: {
        severity: 'success',
        text: 'Your case was closed successfully!'
    },
    // 5 and 6 are the two "this case is over" statuses, and the ONE thing they must not
    // do is name the event with a word the badge might contradict. The client's label
    // map (common.ts CASE_STATUSES) calls 5 "deleted" and 6 "canceled"; the SERVER calls
    // 5 "canceled" and 6 "deleted" (server/src/v1/modules/case/config.json). The copy
    // used to lean on the client map's names, which made the pairing coherent only for
    // as long as that inversion stood - correct one half and the other half lies.
    //
    // So the copy names the ACTOR and the EVENT instead, and no longer uses the words
    // "deleted" or "canceled" at all. Both sentences stay true whichever way the map is
    // eventually resolved, and neither can contradict the badge beside it.
    //
    //   5 = the consumer ended their own case: deleteCase (services.ts:165), an approved
    //       or expired unmatch (unmatchServices.ts:130) and the resubmit that supersedes
    //       it (resubmitServices.ts:150) all write it. Every one is consumer-initiated.
    //   6 = a system auto-cancel. THREE different jobs write it and they do NOT share a
    //       cause, so this copy must not name one:
    //         cancelExpiredCases    - 2 days old, no proposals at all
    //         cancelInProcessCases  - 10 days old, proposals DID arrive, none chosen
    //         cancelPastDueCases    - the appointment date passed by 6 business hours,
    //                                 which can fire on an already-MATCHED case
    //       The server distinguishes them via SystemCancelKind
    //       (noInterest / noSelection / deadlinePassed); if this box ever needs the
    //       specific reason, plumb that through rather than guessing from the status.
    5: {
        severity: 'error',
        text: 'This case was ended at your request and is no longer active.'
    },
    6: {
        severity: 'error',
        text: 'The AppearMe system ended this case and it is no longer active. Any amount held for it has been refunded.'
    },
    7: {
        severity: 'error',
        text: 'You have Rejected the product and/or the services submitted by this lawyer. We will review this matter, give the lawyer to resubmit his/her product and/or the services or have another lawyer complete it.'
    },
    8: {
        severity: 'success',
        text: 'The AppearMe team has reviewed your rejection and request for review. At this time we have determined that the work products and/or the services submitted by the lawyer is sufficient and final.'
    },
    9: {
        severity: 'error',
        text: 'The AppearMe team has reviewed your rejection and request for a REVIEW. At this time we have determined that the work product and/or the services submitted by the lawyer do not meet the requirements outlines by you.'
    },
    // 20 / 21 - the unmatch (reject the matched attorney) states. Keyed by the SERVER's
    // status numbers, same as every other entry here.
    20: {
        severity: 'warning',
        text: 'We have asked the lawyer to release this case. They have 6 business hours - Monday to Friday, 9:00 AM to 5:00 PM only, so a request made on a Friday afternoon or over a weekend will not run out until a weekday - to accept or object. Either way, once that window closes the case is canceled and your payment is refunded in full. You can then resubmit it to be matched with a different lawyer.'
    },
    21: {
        severity: 'warning',
        text: 'The lawyer has objected to releasing this case, so the AppearMe team is now reviewing it. We will be in touch with a decision - no further action is needed from you, and you have not been charged anything extra.'
    },
};

// The unmatch window, phrased around the REAL deadline whenever the case carries one.
//
// GET /case/:case_uid now returns `unmatch_request`, so at status 20 we can say WHEN the
// lawyer's window closes instead of only restating the rule. The generic sentence above
// stays as the fallback for a payload without the row.
const formatDeadline = (expiresAt: any): string | null => {
    if (!expiresAt) return null;
    const date = new Date(expiresAt);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
};

/**
 * The notification for a case, deadline folded in.
 *
 * Only status 20 is ever rewritten; every other status returns the entry above byte for
 * byte (including status 3, whose `text` is a per-payment-type object NotificationBox
 * resolves itself).
 */
const caseStatusNotification = (caseData: any) => {
    const status = caseData?.status || 0;
    const base = CaseStatusNotifications[status];
    if (!base || status !== 20) return base;
    const by = formatDeadline(caseData?.unmatch_request?.expires_at);
    if (!by) return base;
    return {
        ...base,
        text: `${base.text} Their window closes on ${by}.`
    };
};

export default {
    CaseStatusNotifications,
    caseStatusNotification
}
